import { Box, Grid2, Typography } from '@mui/material';

import type { ShuffledEntry } from '@/types/reading';

import FaceDownCard from './FaceDownCard';
import { faceDownDeckGridSx, faceDownDeckTitleSx } from './FaceDownDeck.styles';

interface Props {
  shuffled: ShuffledEntry[];
  cardBack: string | null;
  requiredCards: number;
  onToggle: (shuffleIndex: number) => void;
}

function FaceDownDeck({ shuffled, cardBack, requiredCards, onToggle }: Props) {
  if (shuffled.length === 0 || !cardBack) return null;

  return (
    <Box>
      <Typography variant="h6" sx={faceDownDeckTitleSx}>
        Select {requiredCards} card{requiredCards !== 1 ? 's' : ''} for your reading
      </Typography>
      <Grid2 container spacing={1.5} sx={faceDownDeckGridSx}>
        {shuffled.map((entry) => (
          <Grid2 key={entry.shuffleIndex} size="auto">
            <FaceDownCard
              index={entry.shuffleIndex}
              selected={entry.selected}
              cardBack={cardBack}
              onToggle={() => onToggle(entry.shuffleIndex)}
            />
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
}

export default FaceDownDeck;
